import React from "react";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function ItemSelectChip({
  selectedItem,
  setSelectedItem,
  itemList,
  disabledProps,
}) {
  const onChangeSelectedMchName = (e) => {
    const {
      target: { value },
    } = e;
    const selectedItemData = itemList.find((item) => item.item_name === value);
    setSelectedItem(selectedItemData ? [selectedItemData.item_id] : []);
  };
  return (
    <FormControl>
      <InputLabel id="demo-multiple-chip-label">아이템명</InputLabel>
      <Select
        maxRows="1"
        value={selectedItem.length > 0 ? selectedItem : []}
        onChange={onChangeSelectedMchName}
        input={<OutlinedInput id="select-multiple-chip" label="아이템명" />}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected.length > 0 ? (
              selected.map((value) => (
                <Chip key={value} label={value} style={{ height: "90%" }} />
              ))
            ) : (
              <em>선택하세요</em>
            )}
          </Box>
        )}
        MenuProps={MenuProps}
        disabled={disabledProps}
      >
        {itemList?.map((name) => (
          <MenuItem key={name.item_id} value={name.item_name}>
            {name.item_name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default ItemSelectChip;
